module.exports = __webpack_public_path__ + "media/test/step_final-033c236e.png";